import { Provider } from "@redotech/redo-model/order";
import * as z from "zod";

export const searchCollections = {
  name: "searchCollections" as const,
  input: z.object({
    searchTerm: z.string().optional(),
    provider: z.enum(Provider),
  }),
  output: z.array(z.object({ id: z.string(), name: z.string() })),
};
